import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header/Header';
import { fetchAccountInfo } from '../actions/accountInfo.actions';
import CreateObjectivePanel from './Objectives/CreatePanel';
import ObjectivesInfoPanel from './ObjectivesInfoPanel/ObjectivesInfoPanel';
import {
  Box,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { fetchEmployeeData } from '../actions/employee.action';
import { setUserLanguage } from '../utils/language';
import Filters from './Filters/Filters';
import { NAVIGATION_DRAWER_WIDTH } from '../utils/const';
import FilterProvider from '../components/Filters/FilterProvider';
import Objectives from './Objectives/Objectives';

const useStyles = makeStyles({
  button: {
    margin: 16
  },
  description: {
    marginTop: '20px',
    fontSize: '18px',
    marginLeft: '20px'
  }
});

const UserMainPage = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));

  const objectivesSettings = useSelector(state => state.accountInfo.objectivesSettings ?? {});
  const employee = useSelector(state => state.employee);

  const [ drawerOpen, setDrawerOpen ] = useState(false);
  useEffect(() => {
    dispatch(fetchAccountInfo());
    if (JSON.stringify(employee) === '{}') {
      dispatch(fetchEmployeeData()).then(employee => {
        setUserLanguage(employee?.language);
      });
    }
  }, [ dispatch, employee ]);

  return (
    <FilterProvider>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen }/>
      <div style={ {
        marginLeft: !sm ? 'auto' : drawerOpen ? `${NAVIGATION_DRAWER_WIDTH}px` : '55px'
      } }>
        { objectivesSettings.objectives_instructions &&
        <p className={ classes.button }>{ objectivesSettings.objectives_instructions }</p>
        }
        { objectivesSettings.proposable_by_owner &&
      <div className={ classes.button }>
        <CreateObjectivePanel/>
      </div>
        }
        <ObjectivesInfoPanel/>
        <Box m={ 2 }>
          <Filters/>
        </Box>
        <Objectives />
      </div>
    </FilterProvider>
  );
};

export default UserMainPage;
